/**
 * Page size requested from a library list endpoint. The backend accepts
 * `[1, 500]` and defaults to `100`, and **rejects an out-of-range `limit`
 * with a 400 rather than clamping it** — so this must stay inside the range.
 * Sent explicitly so paging is predictable.
 */
export const METADATA_LIBRARY_PAGE_LIMIT = 100;

/**
 * How long a field catalog (`GET …/{collection}/fields`) stays fresh. The
 * catalog supplies constraints and dictionary options for frontend-owned fields;
 * taxonomy options may change independently of the contract version.
 */
export const METADATA_LIBRARY_FIELDS_STALE_TIME = 60 * 60_000;

/**
 * How long library records stay fresh. Library curation is deliberate and
 * infrequent, and every mutation invalidates the affected keys directly, so a
 * minute of staleness never shows a write back as unapplied.
 */
export const METADATA_LIBRARY_STALE_TIME = 60_000;

/** Placeholder rows on a cold library list load — roughly a first screen. */
export const METADATA_LIBRARY_SKELETON_ROWS = 8;
